<!-- omkar khamkar 2026-03-23 -->
<div
  class="table-paginator"
  *ngIf="data.totalPages > 1 || data.showRowsPerPage"
  [class.no-rows-per-page]="!data.showRowsPerPage"
  [class.variant-staff]="data.variant === 'staff'"
  [class.variant-applicant]="data.variant === 'applicant'"
>
  <div
    class="paginator-left"
    *ngIf="data.showRowsPerPage || data.showTotalRecords"
  >
    <!-- Added by amisha on 05/07/2027 to support optional pagination focus suppression from shared-table pages.
         Reason: pagination buttons should remain configurable without changing their click behavior. -->
    <!-- <button
    *ngIf="data.showRowsPerPage"
      class="rows-dropdown-trigger"
      type="button"
      [attr.tabindex]="disableKeyboardFocus ? -1 : null"
      [matMenuTriggerFor]="rowsPerPageMenu"
      #rowsMenuTrigger="matMenuTrigger"
      [class.open]="rowsMenuTrigger.menuOpen"
      aria-label="Rows per page menu">
      <span class="rows-label">Rows per page {{ data.pageSize }}</span>
      <wm-common-icon
        class="rows-dropdown-arrow"
        [data]="{ iconName: 'keyboard_arrow_up' }">
      </wm-common-icon>
    </button> -->

    <!-- <mat-menu
      #rowsPerPageMenu="matMenu"
      yPosition="below"
      xPosition="after"
      panelClass="rows-per-page-menu-panel"> -->
    <!-- Added by amisha on 05/07/2027 to keep rows-per-page options aligned with the pagination focus configuration.
           Reason: menu items should follow the same optional tab-order rule as the pagination trigger. -->
    <!-- <button
        mat-menu-item
        type="button"
        class="rows-per-page-menu-item"
        [attr.tabindex]="disableKeyboardFocus ? -1 : null"
        [class.selected]="isCurrentPageSize(size)"
        [attr.aria-selected]="isCurrentPageSize(size)"
        [style.background-color]="isCurrentPageSize(size) ? 'rgba(225, 245, 254, 1)' : 'transparent'"
        [disableRipple]="true"
        *ngFor="let size of data.pageSizeOptions"
        (click)="onPageSizeChange(size)">
        <span class="rows-per-page-menu-text">{{ size }}</span>
      </button>
    </mat-menu> -->
    <mat-paginator
      *ngIf="data.showRowsPerPage"
      class="rows-per-page-paginator"
      [length]="data.totalRecords || 0"
      [pageSize]="data.pageSize"
      [pageSizeOptions]="data.pageSizeOptions"
      [showFirstLastButtons]="false"
      (page)="onPaginatorChange($event)"
    >
    </mat-paginator>
    <span class="total-records" *ngIf="data.showTotalRecords">
      <!-- {{   data.selectedRecords || 0 }} selected / -->
      Total Records: {{ data.totalRecords | number }}
    </span>
  </div>

  <div class="paginator-right" [class.full-width]="!data.showRowsPerPage">
    <!-- Added by amisha on 05/07/2027 to reuse the shared pagination focus toggle for navigation buttons.
         Reason: page controls may need to stay focusable or be skipped depending on the hosting page. -->
    <button
      *ngIf="data.variant === 'staff'"
      class="staff-page-btn"
      [attr.tabindex]="disableKeyboardFocus ? -1 : null"
      (click)="first.emit()"
      [disabled]="!data.canGoPrevious"
    >
      <div class="pagination-left-icon">
        <wm-common-icon [data]="{ iconName: 'skip_previous' }"></wm-common-icon>
      </div>
    </button>

    <button
      class="staff-page-btn"
      [attr.tabindex]="disableKeyboardFocus ? -1 : null"
      (click)="previous.emit()"
      [disabled]="!data.canGoPrevious"
    >
      <div class="pagination-left-icon">
        <wm-common-icon [data]="{ iconName: 'chevron_left' }"></wm-common-icon>
      </div>
    </button>

    <ng-container *ngFor="let page of data.visiblePages">
      <!-- Added by amisha on 05/07/2027 to reuse the shared pagination focus toggle for page number buttons.
           Reason: page numbers should follow the same optional tab-order rule as the rest of the paginator. -->
      <button
        *ngIf="page !== 'dots'"
        class="staff-page-number"
        [attr.tabindex]="disableKeyboardFocus ? -1 : null"
        [class.active]="page === data.currentPage"
        (click)="onPageSelect(page)"
      >
        {{ page + 1 }}
      </button>

      <span *ngIf="page === 'dots'" class="pagination-dots">...</span>
    </ng-container>

    <button
      class="staff-page-btn"
      [attr.tabindex]="disableKeyboardFocus ? -1 : null"
      (click)="next.emit()"
      [disabled]="!data.canGoNext"
    >
      <div class="pagination-left-icon">
        <wm-common-icon [data]="{ iconName: 'chevron_right' }"></wm-common-icon>
      </div>
    </button>

    <button
      *ngIf="data.variant === 'staff'"
      class="staff-page-btn"
      [attr.tabindex]="disableKeyboardFocus ? -1 : null"
      (click)="last.emit()"
      [disabled]="!data.canGoNext"
    >
      <div class="pagination-left-icon">
        <wm-common-icon [data]="{ iconName: 'skip_next' }"></wm-common-icon>
      </div>
    </button>
  </div>
</div>
